import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { debounce, get, isEmpty } from 'lodash';
import classnames from 'classnames';
import AddOnsTable from '../../fieldSets/AddOnsTable/add-ons-table';
import { ADD_ITEMS_FORM } from '../../constants/formNames';
import AddOnsSectionMobile from '../../fieldSets/AddOnsSectionMobile/add-ons-section-mobile';
import Button from '../../../../../elements-buttons/Button';
import submitAddItemsForm from '../../submit/submitAddItemsForm';
import onChangeAddItemsForm from '../../onChange/onChangeAddItemsForm';
import validateAddItemsForm from '../../validate/validateAddItemsForm';
import { FormattedMessage } from 'react-intl';

const AddItemsForm = ({
  ssoId = '',
  inventory = {},
  currency = '',
  openModal = null,
  toggleModal = null,
  items = [],
  getInventoryItem = null,
  isMobile = false,
  viewAddOnDetailsAction = null,
  editAddOnAction = null,
  editBookingAddOn = null,
  openEditBookingAddOnModal = null,
  handleItemChange = null,
  navigateBack = null,
  handleSubmit = null,
  isPatching = false,
  contract = {}
}) => {
  const masterContract = get(contract, 'quote.master');
  const hostAddOnsSummary = get(masterContract, 'calculations.host_add_ons_summary', {});

  const [addOnsSummaryLoading, setAddOnsSummaryLoading] = useState();

  useEffect(() => {
    const summaryLoading = items?.length && isEmpty(hostAddOnsSummary)
    setAddOnsSummaryLoading(summaryLoading);
  }, [items, hostAddOnsSummary])

  return (
    <form className="add-items-form" onSubmit={handleSubmit}>
      <h5>
        <FormattedMessage
          id='inbox.add_items_form.added'
          defaultMessage='Added to booking'
        />
      </h5>
      <AddOnsSectionMobile
        ssoId={ssoId}
        inventory={inventory}
        currency={currency}
        openModal={openModal}
        toggleModal={toggleModal}
        items={items}
        getInventoryItem={getInventoryItem}
        viewAddOnDetailsAction={viewAddOnDetailsAction}
        editAddOnAction={editAddOnAction}
        editBookingAddOn={editBookingAddOn}
        openEditBookingAddOnModal={openEditBookingAddOnModal}
        masterContract={masterContract}
        hostAddOnsSummary={hostAddOnsSummary}
        contract={contract}
        addOnsSummaryLoading={addOnsSummaryLoading}
      />

      <AddOnsTable
        inventory={inventory}
        currency={currency}
        openModal={openModal}
        toggleModal={toggleModal}
        items={items}
        getInventoryItem={getInventoryItem}
        viewAddOnDetailsAction={viewAddOnDetailsAction}
        editAddOnAction={editAddOnAction}
        handleItemChange={handleItemChange}
        contract={contract}
        masterContract={masterContract}
        hostAddOnsSummary={hostAddOnsSummary}
        ssoId={ssoId}
        className="d-xs-none d-sm-block"
        addOnsSummaryLoading={addOnsSummaryLoading}
      />

      <div className="help-block text-danger text-right">
        {contract.error
          && <FormattedMessage
            id='inbox.add_items_form.something_wrong'
            defaultMessage='Something went wrong, please try again.'
          />
        }
      </div>

      <hr />
      <div
        className={
          classnames(
            'ctas flex space-between',
            { column: isMobile,
              'flex-column-reverse': isMobile
            }
          )
        }
      >
        <Button
          onClick={navigateBack}
          attributes={{ type: 'button', 'data-testing-id': 'back-btn' }}
          category="default"
          type="button"
        >
          <FormattedMessage
            id='inbox.add_items_form.back'
            defaultMessage='Back'
          />
        </Button>
        <Button
          isLoading={isPatching}
          attributes={{ 'data-testing-id': 'continue-to-review-booking-btn' }}
          category="primary"
        >
          <FormattedMessage
            id='inbox.add_items_form.continue'
            defaultMessage='Continue to Review Booking'
          />
        </Button>
      </div>
    </form>
  );
};

AddItemsForm.propTypes = {
  currency: PropTypes.string,
  toggleModal: PropTypes.func,
  openModal: PropTypes.func,
  items: PropTypes.array,
  getInventoryItem: PropTypes.func,
  inventory: PropTypes.object,
  isMobile: PropTypes.bool,
  viewAddOnDetailsAction: PropTypes.func,
  editAddOnAction: PropTypes.func,
  openEditBookingAddOnModal: PropTypes.func,
  handleItemChange: PropTypes.func,
  contract: PropTypes.object,
  isPatching: PropTypes.bool,
  handleSubmit: PropTypes.func,
  navigateBack: PropTypes.func,
  editBookingAddOn: PropTypes.func
};

const config = {
  form: ADD_ITEMS_FORM,
  onSubmit: submitAddItemsForm,
  onChange: debounce(onChangeAddItemsForm, 300),
  validate: validateAddItemsForm
};

export default reduxForm(config)(AddItemsForm);
